import i18n from "i18next";
import { z } from "zod";
import { getAtsMustNotBeInPastError, getEtcDateOrderError, notificationSchema } from "../utils";
import { parseDateLikeValue } from "./sharedClosePortServiceSchemas";

const createAtsSchema = () =>
  z.object({
    ats: z.preprocess(
      parseDateLikeValue,
      z.date({
        required_error: i18n.t("form-validation.required", { label: "ATS" }),
        invalid_type_error: i18n.t("form-validation.invalid-date", { label: "ATS" }),
      }),
    ),
  });

const createEtcSchema = () =>
  z.object({
    etc: z.preprocess(
      parseDateLikeValue,
      z
        .date({ invalid_type_error: i18n.t("form-validation.invalid-date", { label: "ETC" }) })
        .nullable()
        .optional(),
    ),
  });

export const startDebunkeringSchema = () =>
  createAtsSchema()
    .merge(createEtcSchema())
    .merge(notificationSchema)
    .superRefine((value, ctx) => {
      const atsError = getAtsMustNotBeInPastError(value.ats);

      if (atsError) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["ats"],
          message: atsError,
        });
      }

      const error = getEtcDateOrderError({ etc: value.etc, ats: value.ats });

      if (!error) {
        return;
      }

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["etc"],
        message: error,
      });
    });

export type StartDebunkeringSchema = z.infer<ReturnType<typeof startDebunkeringSchema>>;
